import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';

/**
 * Admin Feature Routes
 *
 * Modern Angular 21+ 패턴:
 * - Standalone components with lazy loading
 * - Role guard integration (ADMIN_SYSTEM)
 * - Child route for detail page
 */
export const adminRoutes: Routes = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full',
  },
  {
    path: 'list',
    loadComponent: () =>
      import(
        './components/smart/admin-list-page/admin-list-page.component'
      ).then((m) => m.AdminListPageComponent),
    canActivate: [roleGuard('ADMIN_SYSTEM')],
    children: [
      {
        path: ':id',
        loadComponent: () =>
          import(
            './components/smart/admin-detail-page/admin-detail-page.component'
          ).then((m) => m.AdminDetailPageComponent),
      },
    ],
  },
];
